module.exports = __webpack_public_path__ + "static/img/glove_bleu_marine.6661f10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_bleu_marine.png
// module id = at6Q
// module chunks = 0